export const PRODUCT = {
  name: "WORD/DUEL",
  shortName: "W/D",
  description: "A private two-player asynchronous word-tile duel."
} as const;

export const BOARD_SIZE = 15;
export const RACK_SIZE = 7;
export const MAX_SELFIE_BASE64_BYTES = 500 * 1024;
export const TIMER_OPTIONS = [3600, 21600, 43200, 86400, 172800, 259200, 604800] as const;
